import React from 'react';

const Week4Newsletter: React.FC = () => {
  return (
    <div className="newsletter-archive">
      <div className="newspaper-container">
        <div className="newspaper-header">
          <div className="newspaper-masthead">
            <h1 className="newspaper-title">AMBERWOOD FANTASY TIMES</h1>
            <div className="newspaper-subtitle">The Premier Source for Fantasy Football News & Analysis</div>
            <div className="newspaper-meta">
              <span className="edition">Week 4 Edition</span>
              <span className="date">September 2025</span>
              <span className="price">FREE</span>
            </div>
          </div>
        </div>

        <div className="newspaper-content">
          <div className="main-story">
            <h2 className="headline">Red October: The Great 2-2 Logjam Creates Unprecedented Parity</h2>
            <div className="byline">By the Office of the Commissioner</div>

            <div className="center-image" style={{marginBottom: '30px', textAlign: 'center', width: '100%'}}>
              <div style={{border: '1px solid #ddd', padding: '20px', borderRadius: '8px', backgroundColor: '#f9f9f9', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', display: 'inline-block', maxWidth: '700px', width: '100%'}}>
                <img src="/IMG_5BFFF4709E99-1.jpeg" alt="Week 4 Highlights" style={{width: '100%', maxWidth: '680px', height: 'auto', border: '2px solid #333', borderRadius: '4px'}} />
                <div className="draft-caption" style={{fontSize: '12px', fontStyle: 'italic', textAlign: 'center', marginTop: '10px'}}>
                  Have the demons finally been put to rest? Is it Sahil's time?
                </div>
              </div>
            </div>

            <div className="story-layout">
              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🌟 Week 4 Summary</h3>
                <p>Week 4 delivered the closest game in league history and created an unprecedented 2-2 logjam with 8 teams tied for the middle of the standings. pranavj20 remains perfect at 4-0 while chaos reigns below.</p>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>📊 Week 4 Matchup Recap</h3>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🔥 Statement Performances</h3>

                <div className="matchup-result">
                  <h4>"THRILLER IN OHIO: Swahili Edges Pranav P by 0.24 Points!" swahili28 (164.76) def. pranav4789 (164.52)</h4>
                  <p><strong>Winner Analysis:</strong> In the closest game of the season, swahili28 survived by just 0.24 points - less than one reception. Ja'Marr Chase's disappointing 7.30 points was just enough to get the team over the line. This is the kind of heart attack-inducing win that makes or breaks seasons. Something Sahil's teams haven't done well with in the past.</p>
                  <p><strong>Loser Analysis:</strong> pranav4789's 164.52 points should have been a sure fire win. The agony of losing despite putting up 164 is unfathomable. ARSB and the supporting cast delivered, but faced a tough opponent.</p>
                </div>

                <div className="matchup-result">
                  <h4>"THE MAHOMES MASTERCLASS: Kulkdaddy Explodes for Week's Highest Total" kulkdaddy47 (173.45) def. abhiu (167.49)</h4>
                  <p><strong>Winner Analysis:</strong> kulkdaddy47's 173 points represent the week's highest total, powered by Patrick Mahomes' elite 27.30-point performance. The Jets duo and supporting cast all delivered in a complete team performance that showcased their championship ceiling.</p>
                  <p><strong>Loser Analysis:</strong> abhiu's 167 points also would have won most matchups this week. This 0-4 team should have gotten off the mark with their first win of the season after rookie Ashton Jeanty had a monster performance.</p>
                </div>

                <div className="matchup-result">
                  <h4>"PLAYOFF STATEMENT: SahitReddi Finally Breaks Through" SahitReddi (170.68) def. roshik (116.80)</h4>
                  <p><strong>Winner Analysis:</strong> SahitReddi's season-high 170 points represent a complete roster explosion. After weeks of underperformance from elite talent, everything finally clicked simultaneously. Bijan Robinson and the supporting cast all delivered career weeks.</p>
                  <p><strong>Loser Analysis:</strong> roshik's 116 points show regression from their early season form. Saquon Barkley and the balanced attack that carried them early couldn't keep pace with SahitReddi's eruption.</p>
                </div>
              </div>

              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>⚔️ Competitive Battles</h3>

                <div className="matchup-result">
                  <h4>"REVENGE COMPLETE: Audumula Bounces Back" audumula (127.21) def. ankithe (106.63)</h4>
                  <p><strong>Winner Analysis:</strong> After multiple disappointing weeks, audumula finally put together a complete 127-point performance. This is the type of win that can turn a season around, defeating a quality opponent convincingly.</p>
                  <p><strong>Loser Analysis:</strong> ankithe's 106 points represent their worst performance of the season. CMC's solid 25.10 points couldn't overcome a devastating week of injuries. A loss is something the team can overcome, but the injury bug might not be.</p>
                </div>

                <div className="matchup-result">
                  <h4>"BOOM-BUST CONTINUES: Abhishek Escapes" abhishekD (128.05) def. taahakm (97.96)</h4>
                  <p><strong>Winner Analysis:</strong> abhishekD's 128 points continue their pattern of alternating performances. Derrick Henry's quiet 7.80 points shows this team is finding ways to win without elite RB production - a concerning sign for sustainability.</p>
                  <p><strong>Loser Analysis:</strong> taahakm's 97 points end their surprising hot streak. After winning close games early, the luck finally ran out with their lowest scoring output of the season.</p>
                </div>

                <div className="matchup-result">
                  <h4>"PERFECTION CONTINUES: Pranav Jain Stays Unbeaten" pranavj20 (167.48) def. akhilmetukuru (84.17)</h4>
                  <p><strong>Winner Analysis:</strong> pranavj20's 167 points maintain their perfect 4-0 record. Josh Jacobs finally had his break out game. This team has a real path to going undefeated with such a star studded lineup from top to bottom.</p>
                  <p><strong>Loser Analysis:</strong> akhilmetukuru's catastrophic 84 points represent rock bottom. After their breakthrough Week 3 victory, this team completely regressed to their worst performance yet.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="parity-analysis">
            <h2 className="section-headline">📊 The Great 2-2 Logjam: Unprecedented League Parity</h2>
            <p><strong>Current State:</strong> 8 out of 12 teams (67% of the league) sit at exactly 2-2 after Week 4 - an unprecedented level of parity that will shape the rest of the season.</p>

            <div className="parity-section">
              <h3>🏆 The Standings Reality Check</h3>

              <div className="standings-breakdown">
                <h4>Clear Separation:</h4>
                <ul>
                  <li><strong>Tier 1:</strong> pranavj20 (4-0) - Clearly the best team</li>
                  <li><strong>Tier 2:</strong> abhishekD (3-1) - Established contender</li>
                  <li><strong>The Massive Middle:</strong> 8 teams at 2-2 - Anyone's game</li>
                  <li><strong>The Bottom:</strong> akhilmetukuru (1-3), abhiu (0-4) - Fighting for survival</li>
                </ul>
              </div>

              <h3>📈 Points For Will Decide Everything</h3>
              <p>With 8 teams tied in record, points for becomes the critical tiebreaker for playoff seeding. Here's the current spread among 2-2 teams:</p>

              <div className="points-breakdown">
                <div className="points-list">
                  <p><strong>pranav4789:</strong> 598 PF (1st overall!)</p>
                  <p><strong>kulkdaddy47:</strong> 554 PF</p>
                  <p><strong>ankithe:</strong> 543 PF</p>
                  <p><strong>swahili28:</strong> 539 PF</p>
                  <p><strong>SahitReddi:</strong> 526 PF</p>
                  <p><strong>roshik:</strong> 500 PF</p>
                  <p><strong>audumula:</strong> 490 PF</p>
                  <p><strong>taahakm:</strong> 476 PF</p>
                </div>
                <p><strong>The Implications:</strong> pranav4789 has a 122-point advantage over taahakm despite the same record. That's nearly 31 points per week - enough to make or break playoff seeding.</p>
              </div>

              <h3>🎯 Schedule Luck Has Been Extreme</h3>
              <div className="luck-analysis">
                <p><strong>pranav4789:</strong> Most points in league (598) but only 2-2 - incredibly unlucky</p>
                <p><strong>taahakm:</strong> Second-lowest points (476) but 2-2 - incredibly lucky</p>
                <p><strong>abhiu:</strong> Middle-of-pack points (477) but 0-4 - catastrophically unlucky</p>
                <p>This means the "true" strength of teams at 2-2 varies wildly. Some teams are legitimate contenders while others are pretenders riding favorable matchups.</p>
              </div>
            </div>
          </div>

          <div className="team-analysis">
            <h2 className="section-headline">🏆 Power Rankings (Post-Week 4)</h2>

            <div className="power-rankings-section">
              <h3>Tier 1: Championship Elite</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>1. pranavj20 (4-0, 595 PF)</h4>
                  <p><strong>Season Story:</strong> The league's only undefeated team continues their march toward perfection with a 167-point demolition. After a disastrous 0-3 start last season, Puka Nacua's health has transformed this franchise into an unstoppable force.</p>
                  <p><strong>Team MVP:</strong> Puka Nacua - The #1 overall player with 23, 27, 22, and 36 points is on pace to outscore the top QBs</p>
                </div>

                <div className="team-card">
                  <h4>2. abhishekD (3-1, 544 PF)</h4>
                  <p><strong>Season Story:</strong> The king of boom-or-bust continues his wild ride: 166 (W) → 93 (L) → 156 (W) → 128 (W). When everything clicks, this team has shown the highest ceiling in the league.</p>
                  <p><strong>Team MVP:</strong> Rome Odunze - 80 points through 4 weeks, averaging 20 ppg as the Bears number 1 option</p>
                </div>

                <div className="team-card">
                  <h4>3. pranav4789 (2-2, 598 PF) ⬆️ +1</h4>
                  <p><strong>Season Story:</strong> Despite a heartbreaking 0.24-point loss, this team has the highest points for (598) in the league. The young roster continues to develop with ARSB providing consistent WR1 production.</p>
                  <p><strong>Team MVP:</strong> Amon-Ra St. Brown - 8.50 → 39.20 → 20.70 → 26.00 shows elite consistency</p>
                </div>
              </div>

              <h3>Tier 2: Playoff Contenders</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>4. kulkdaddy47 (2-2, 554 PF) ⬆️ +3</h4>
                  <p><strong>Season Story:</strong> Exploded for a season-high 173 points to even their record at 2-2. Patrick Mahomes' elite 27.30-point performance reminded everyone why elite QB play wins championships.</p>
                  <p><strong>Team MVP:</strong> Patrick Mahomes - Proving his worth with consistent elite QB production and championship ceiling</p>
                </div>

                <div className="team-card">
                  <h4>5. swahili28 (2-2, 539 PF) ⬆️ +2</h4>
                  <p><strong>Season Story:</strong> Survived by 0.24 points in the most dramatic fashion possible. The boom-or-bust pattern continues, but they're winning the close games that matter.</p>
                  <p><strong>Team MVP:</strong> James Cook - 91 points through 4 weeks with excellent efficiency</p>
                </div>

                <div className="team-card">
                  <h4>6. SahitReddi (2-2, 526 PF) ⬆️ +4</h4>
                  <p><strong>Season Story:</strong> Finally put it all together with a season-high 170-point explosion. This breakthrough performance could be the turning point from disappointment to contender.</p>
                  <p><strong>Team MVP:</strong> Bijan Robinson - When Bijan delivers on his elite RB1 potential, this entire roster elevates</p>
                </div>
              </div>

              <h3>Tier 3: Bubble Teams</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>7. ankithe (2-2, 543 PF) ⬇️ -2</h4>
                  <p><strong>Season Story:</strong> The early season powerhouse stumbled with a season-low 106 points. CMC's reliable 25.10 points couldn't overcome the team-wide injury apocalypse. They need to find another avenue for points with Malik Nabers out for the season with an ACL injury.</p>
                  <p><strong>Team MVP:</strong> Christian McCaffrey - The ultimate consistency: 23.20 → 22.70 → 24.00 → 25.10</p>
                </div>

                <div className="team-card">
                  <h4>8. roshik (2-2, 500 PF) ⬇️ -3</h4>
                  <p><strong>Season Story:</strong> A disappointing 116-point performance revealed cracks in their early season success. Sitting with exactly 500 points for, they need additional scoring sources beyond Saquon.</p>
                  <p><strong>Team MVP:</strong> Saquon Barkley - Still the team's engine despite recent struggles</p>
                </div>

                <div className="team-card">
                  <h4>9. audumula (2-2, 490 PF) ⬆️ +1</h4>
                  <p><strong>Season Story:</strong> With just 490 points for (9th in league), this team needs to find more reliable weekly production to stay in playoff contention. The consistency is there, but we have yet to see a true championship ceiling.</p>
                  <p><strong>Team MVP:</strong> Josh Allen - Provides the elite QB ceiling needed to win big games. ~25 ppg is exactly what audumula was hoping for from the best player in the NFL.</p>
                </div>

                <div className="team-card">
                  <h4>10. taahakm (2-2, 476 PF) ⬇️ -4</h4>
                  <p><strong>Season Story:</strong> After winning close games through luck in Weeks 1-3, reality has set in. With the league's second-lowest points for (476), this team is running on fumes.</p>
                  <p><strong>Team MVP:</strong> Jahmyr Gibbs - The only reliable source of weekly points on this roster</p>
                </div>
              </div>

              <h3>Tier 4: Desperation Mode</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>11. akhilmetukuru (1-3, 467 PF)</h4>
                  <p><strong>Season Story:</strong> After a breakthrough Week 3 victory (151 pts), crashed back to earth with a catastrophic 84-point disaster. With just 467 points for (lowest), they lack consistent scoring.</p>
                  <p><strong>Team MVP:</strong> Jonathan Taylor - 89.7 points through 4 weeks, currently the RB3 and overall #7</p>
                </div>

                <div className="team-card">
                  <h4>12. abhiu (0-4, 477 PF)</h4>
                  <p><strong>Season Story:</strong> With 477 points for, they're not the worst team talent-wise, but matchup luck has been catastrophic. The 0-4 record is an extremely steep hill to climb back from.</p>
                  <p><strong>Team MVP:</strong> Cam Skattebo - The late round pick has emerged as the Giants RB1 and is currently the RB18</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mickey-award">
            <h2 className="section-headline">🍀 Mickey of the Week Award (Lucky Charm Edition)</h2>

            <div className="award-section">
              <h3>"Winner": audumula (Anudeep) - The Injury Beneficiary</h3>
              <p>Sometimes fantasy football isn't about having the best lineup - it's about your opponent having the worst possible luck. audumula takes home this week's Mickey Award for catching every break imaginable in their 127-21 victory over ankithe, who suffered through an absolute injury apocalypse.</p>

              <div className="collapse-stats">
                <h4>The Injury Disaster That Gifted a Win:</h4>
                <ul>
                  <li><strong>Malik Nabers:</strong> Tore his ACL in the 1st quarter - season-ending injury</li>
                  <li><strong>Ricky Pearsall:</strong> Got injured in the 3rd quarter - early exit</li>
                  <li><strong>Jaylen Warren:</strong> Last-minute scratch - couldn't even play</li>
                  <li><strong>Final Margin:</strong> Won by 20.58 points against a depleted lineup</li>
                </ul>

                <h4>The Lucky Break Down:</h4>
                <p>Instead of facing a healthy ankithe lineup, audumula faced a team that lost 35-45 points of expected production due to injuries, turning a likely victory into a devastating loss for their opponent.</p>

                <p>This Mickey Award comes with a get-well-soon card for ankithe and a reminder that sometimes it's better to be lucky than good. audumula didn't win this game - ankithe's injury report lost it.</p>
              </div>
            </div>
          </div>

          <div className="season-outlook">
            <h2 className="section-headline">🔮 Season Outlook: Welcome to Chaos</h2>
            <p>This 2-2 logjam is unprecedented and means one thing: The next 3-4 weeks will be absolute chaos as teams desperately try to separate themselves from the pack.</p>

            <div className="chaos-predictions">
              <h3>Expect:</h3>
              <ul>
                <li><strong>Increased trade activity</strong> (desperate teams make moves)</li>
                <li><strong>Aggressive waiver wire battles</strong> (every roster spot matters)</li>
                <li><strong>Higher stakes every single week</strong> (no margin for error)</li>
                <li><strong>Potential for teams to go on runs</strong> (3-4 game winning streaks vault you to #3 seed)</li>
              </ul>

              <p><strong>The Bottom Line:</strong> The season is FAR from decided. Any of these 8 teams could realistically finish anywhere from 3rd to 10th place depending on how the next month goes. Welcome to the most competitive fantasy football season in recent memory!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Week4Newsletter;